/**
 * Shared visual recipe for labels rendered inside a field border.
 * Component-specific state selectors and small position tweaks stay local.
 */
export const floatingFieldLabelClassName =
  'eye:body-s-highlight eye:block eye:truncate eye:leading-22! eye:text-black';

/**
 * Shared positioning for labels that float on top of a field border.
 * Components still provide their own `top-*` offset.
 */
export const floatingFieldLabelInsetClassName =
  'eye:absolute eye:left-12 eye:z-10 eye:m-0 eye:max-w-[calc(100%-32px)] eye:-translate-y-1/2 eye:bg-label-gradient eye:px-[3px] eye:leading-none eye:whitespace-nowrap';
